<ion-header class="ion-no-border page menu-page">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/dashboard"></ion-back-button>
    </ion-buttons>
    <ion-title mode="ios"(click)="devMode()">
      <div class="leada-powered">POWERED BY LEADA AG</div>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goBack()">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content class="ion-padding page" no-bounce>

  <ion-list lines="none menu">
    <ion-item button (click)="goHome()"><div translate>MENU.HOME</div></ion-item>
    <ion-item button (click)="showPage('knowhow', $event)" *ngIf="showMenuEntry('MENU.KNOWHOW.NAME')"><div translate>MENU.KNOWHOW.NAME<ion-badge *ngIf="newContentCount" button-end class="badge">{{ newContentCount }}</ion-badge></div><div class="line" slot="end"></div></ion-item>
    <ion-item button (click)="showPage('today', $event)" *ngIf="showMenuEntry('MENU.TODAY.NAME')"><div translate>MENU.TODAY.NAME<ion-badge *ngIf="newDialogsCount" button-end class="badge">{{ newDialogsCount }}</ion-badge></div><div class="line" slot="end"></div></ion-item> 
    <ion-item button (click)="showPage('personal', $event)" *ngIf="showMenuEntry('MENU.PERSONAL.NAME')"><div translate>MENU.PERSONAL.NAME<ion-badge *ngIf="newBadgeCount" button-end class="badge">{{ newBadgeCount }}</ion-badge></div><div class="line" slot="end"></div></ion-item>
    <ion-item button (click)="showPage('corefacts', $event)" *ngIf="showMenuEntry('MENU.COREFACTS.NAME')"><div translate>MENU.COREFACTS.NAME</div><div class="line" slot="end"></div></ion-item>
    <!--on-item button (click)="showPage('profile', $event)"><div translate>MENU.PROFILE.NAME</div><div class="line" slot="end"></div></ion-item-->
    <ion-item button (click)="showDevOptions()" *ngIf="devOptionsEnabled"><div translate>DEV_OPTIONS.TITLE</div></ion-item>
  </ion-list>

  <instruction key="menu">{{'INSTRUCTION.MENU' | translate}}</instruction>
</ion-content>

<ion-footer class="page">
  <ion-button fill="clear" shape="round" (click)="showSettings()" class="settings"><ion-icon slot="icon-only"></ion-icon></ion-button>
  <ion-button fill="clear" shape="round" (click)="showSearch()" class="search"><ion-icon slot="icon-only"></ion-icon></ion-button>
</ion-footer>
